import React, { Suspense, useState, useEffect } from "react";
import "./App.css";
import ImageComparison from "./components/ImageComparison";
import { motion } from "framer-motion";

// Ленивая загрузка основного контента
const LazyMainContent = React.lazy(() => 
  new Promise(resolve => {
    setTimeout(() => {
      resolve(import("./components/LazyMainContent"));
    }, Math.random() * 300);
  })
);

function App() {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    // Показываем контент через 1 секунду
    const timer = setTimeout(() => {
      setShowContent(true);
    }, Math.random() * 300);

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen pb-20 bg-gradient-to-b from-purple-light to-blue-light px-4 sm:px-0">
      {/* Header with Logo */}
      <motion.div 
        className="text-center max-w-2xl mx-auto pt-8 pb-4"
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, ease: "easeOut" }}
      >
        <motion.div 
          className="inline-block mb-4"
          initial={{ scale: 0.8, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ duration: 0.6, delay: 0.2, ease: "easeOut" }}
        >
          <motion.img 
            src="/app-logo1.png" 
            alt="AI" 
            className="w-20 h-20 object-contain"
            whileHover={{ scale: 1.1, rotate: 5 }}
            transition={{ duration: 0.3 }}
          />
          <motion.div 
            className="text-purple-dark font-bold text-[16px]"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4, ease: "easeOut" }}
          >
            PornAI
          </motion.div>
        </motion.div>
        <motion.img 
          src="/app-title.png" 
          alt="AI" 
          className=""
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.7, delay: 0.6, ease: "easeOut" }}
        />
      </motion.div>

      <div className="flex max-w-2xl mx-auto flex-col justify-center space-y-4">
        {showContent ? (
          <Suspense fallback={
            <div className="flex justify-center items-center py-20">
              <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-purple-600"></div>
            </div>
          }>
            <LazyMainContent />
          </Suspense>
        ) : (
          <div className="flex justify-center items-center py-20">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-purple-600"></div>
          </div>
        )}
      </div>

      <motion.div
        className="flex justify-center flex-col justify-center fixed bottom-0 w-full left-0 right-0 p-2 bg-white"
        style={{
          display: "flex",
          flexDirection: "row",
          flexWrap: "nowrap",
          alignContent: "center",
          justifyContent: "center",
          alignItems: "center"
        }}
        initial={{ opacity: 0, y: 100 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 1.2, ease: "easeOut" }}
      >
        <motion.button 
          className="download-btn flex flex-col items-center justify-center -space-y-2"
          whileHover={{ 
            scale: 1.05,
            boxShadow: "0 10px 25px rgba(0,0,0,0.2)"
          }}
          whileTap={{ scale: 0.95 }}
          transition={{ duration: 0.2 }}
        >
          <motion.span 
            className="text-xl font-bold text-white mb-0 text-center text-[16px]"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.4 }}
          >
            Download APK Now
          </motion.span>
          <motion.div 
            className="text-sm opacity-90 font-normal text-[12px]"
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 1.6 }}
          >
            Support All 18+ websites
          </motion.div>
        </motion.button>
      </motion.div>
    </div>
  );
}

export default App;
